import React from 'react';

import { IconButton as MUIIconButton, Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';

import colors from '~/values/colors';

import Icon from './Icon';
import styles from './IconButton.module.scss';

const IconButton = ({
    iconFamily, to,
    icon, size, color,
    title, ...others
}) => {

    const Container = to ? Link : MUIIconButton;

    return (
        <Tooltip placement="top" title={title}>
            <Container
                to={to}
                className={styles.container}
                {...others}
            >
                <Icon
                    name={icon}
                    size={size}
                    color={color}
                    family={iconFamily}
                    className={styles.icon}
                />
            </Container>
        </Tooltip>
    );
};

IconButton.defaultProps = {
    size: 25,
    color: colors.callToAction,
};

export default IconButton;
